// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"baa1ce9f","297":"5b274ab4","641":"54ef2eaa","643":"667e8049"}[chunkId] + ".js";
};